'use strict';

export default class VideoBlock2022 {

    constructor() {
        const video = document.querySelector('.ip-video');


        // is the element present on the current page
        if (! video) {
            return;
        }

            $('.video-play-btn-1').on('click', function(e){
                $('.video-play-btn-1').fadeOut();
                $('.ip-video-1 video').trigger('play');
            });
            $('.ip-video-1 video').on('click', function(e){
                $('.video-play-btn-1').fadeIn();
                $('.ip-video-1 video').trigger('pause');
            });
            $('.video-play-btn-2').on('click', function(e){
                $('.video-play-btn-2').fadeOut();
                $('.ip-video-2 video').trigger('play');
            });
            $('.ip-video-2 video').on('click', function(e){
                $('.video-play-btn-2').fadeIn();
                $('.ip-video-2 video').trigger('pause');
            });
            $('.video-play-btn-3').on('click', function(e){
                $('.video-play-btn-3').fadeOut();
                $('.ip-video-3 video').trigger('play');
            });
            $('.ip-video-3 video').on('click', function(e){
                $('.video-play-btn-3').fadeIn();
                $('.ip-video-3 video').trigger('pause');
            });

    }
}
